// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** Get list company GET /api/v1/company */
export async function companyList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.companyListParams,
  options?: { [key: string]: any },
) {
  return request<API.CompanyListDto>('/api/v1/company', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** Change company status PUT /api/v1/company/status */
export async function companyChangeStatus(
  body: API.ChangeCompanyStatusParamDto,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/company/status', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
